import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import * as XLSX from "xlsx";
import ExcelJS from 'exceljs'
import { DataGrid, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton, GridToolbarExport, GridToolbarDensitySelector, } from "@mui/x-data-grid";
import { CloseOutlined } from "@mui/icons-material";
import { Dialog, DialogContent, MenuItem, Select, FormControl, InputLabel, Typography, IconButton, Button, Tooltip, } from "@mui/material";
import OpaqueLoading from "../../components/opaqueLoading/opaqueLoading";
const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

const ModalActionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const FirstButton = styled(Button)`
  margin-right: 10px !important;
`;

const StyledDialogContent = styled(DialogContent)`
  padding: 16px;
`;

const StyledDialog = styled(Dialog)`
  position: relative;
`;

const DataGridContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  height: 400px;
`;

const NoteText = styled(Typography)`
  margin-top: 10px !important;
`;

const Input = styled.input`
  display: none;
`;

const InputFieldContainer = styled.div`
  margin: 20px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap:10px;
  label{
    margin-bottom:0px;
  }
`;

const BulkAddMainRegistration = ({ onClose, fetchData }) => {
    const [loading, setLoading] = useState(false);
    const [failedEntries, setFailedEntries] = useState([]);
    const [showModal, setShowModal] = useState(true);
    const [targetRows, setTargetRows] = useState([]);
    const [selectedRowIds, setSelectedRowIds] = useState([]);
    const [uploaded, setUploaded] = useState(false);
    const [boardData, setBoardData] = useState([])
    const [mediumData, setMediumData] = useState([])
    const [gradeData, setGradeData] = useState([])
    const [contactPersonRole, setContactPersonRole] = useState([])
    const [schoolCategories, setSchoolCategories] = useState([])
    const hiddenFileInput = useRef(null);
    const [view, setView] = useState(false);
    const fileInputRef = useRef(null);
    const [failedData, setFailedData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [fileKey, setFileKey] = useState(0);
    const [display, setDisplay] = useState(false);
    const [isloader, setIsloader] = React.useState(false);
    const [dataId, setDataId] = useState([]);
    const [responseData, setResponseData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedValue, setSelectedValue] = useState('');
    const [uploadStats, setUploadStats] = useState(null); // Store analytics
    const [selectedFile, setSelectedFile] = useState(null); // Track selected file
    const [selectedValueDistributor, setSelectedValueDistributor] = useState('');

    const handleButtonClick = () => {
        fileInputRef.current.click();
    };

    const handleDownload = async () => {
        try {
            const headers = ['registration_type', 'userName', "partyId", "dates_of_olympiad", "reg_medium", "status", "adminRemark", "totalAmount", "rm_remark", "medium", "className",
                "subjectName", "student", "study_material", "mittlernPresent", "paidAmount1", "paidAmount2", "paidAmount3", "paidAmount4", "paidAmount5", "paymentMode", "transactionReference",
                "transactionDate", "transaction_remark", "coordinator_subject_id", "coordinator_name", "coordinator_email", "coordinator_mobile", "coordinator_role", "process"];



            const mandatoryFields = ['registration_type', 'userName', "partyId", "dates_of_olympiad", "reg_medium", "status", "adminRemark", "totalAmount", "rm_remark", "medium", "className",
                "subjectName", "student", "study_material", "mittlernPresent", "paidAmount1", "paidAmount2", "paidAmount3", "paidAmount4", "paidAmount5", "paymentMode", "transactionReference",
                "transactionDate", "transaction_remark", "coordinator_subject_id", "coordinator_name", "coordinator_email", "coordinator_mobile", "coordinator_role", "process"];

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');
            const headerRow = worksheet.addRow(headers);
            headerRow.eachCell((cell, colNumber) => {
                if (mandatoryFields.includes(cell.value)) {
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFFF00' } // Yellow
                    };
                } else {
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFD3D3D3' } // Light gray
                    };
                }
                cell.font = { bold: true };
            });
            const sampleRow = [
                "Registration & Study Material",
                "aa22rr22",
                "S-130208",
                "16-11-2026",
                "ENGLISH",
                "4",
                "Approved",
                "6750",
                "RM Remark",
                "ENGLISH",
                "CLASS 5",
                "MATHS",
                "20",
                "20",
                "1",
                "",
                "5000",
                "1000",
                "N/A",
                "N/A",
                "Net Banking / UPI",
                "TXN000123",
                "25-05-2026",
                "First Payment",
                "MATHS",
                "Amit Kumar",
                "amit@gmail.com",
                "8888888888",
                "Admin",
                "By Admin  /  By RM / Direct"
            ];
            worksheet.addRow(sampleRow);
            headers.forEach((header, idx) => {
                worksheet.getColumn(idx + 1).width = 20;
            });
            workbook.xlsx.writeBuffer().then((buffer) => {
                const blob = new Blob([buffer], { type: 'application/octet-stream' });
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'Registration-Bulk-Template.xlsx';
                a.click();
                URL.revokeObjectURL(url);
                setLoading(false);
            });
        } catch (error) {
            console.error(error);
            setLoading(false);
        }

    };
    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setSelectedFile(file); // Store the selected file
        setFileKey((prevKey) => prevKey + 1);

        console.log(file, "Selected File:", file.name, file.type, file.size);
    };


    const handleUpload = async () => {
        if (!selectedFile) {
            window.NotificationUtils.showError("No file selected for upload.");
            return;
        }

        setLoading(true);
        try {
            const formData = new FormData();
            formData.append("file", selectedFile);

            console.log("Uploading File:", selectedFile.name);


            let response = await window.Platform.database.createBulkGenerateInvoice(formData);

            if (!response) {
                throw new Error("No response from server");
            }

            console.log("Upload Success:", response);


            const successCount = response.data.filter(entry => entry.status === "Success").length;
            const failureEntries = response.data.filter(entry => entry.status === "Failure");
            setUploadStats({ successCount, failureCount: failureEntries.length, total: response.data.length });

            setFailedEntries(failureEntries);
            window.NotificationUtils.showSuccess("File uploaded successfully!");

            setSelectedFile(null);
        } catch (error) {
            console.error("Error uploading file:", error);
            window.NotificationUtils.showError("Error uploading file!");
        } finally {
            setLoading(false);
        }
    };




    const handleDownloadErrorReport = async () => {
        if (failedEntries.length === 0) return;

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Error Report');
        const headers = Object.keys(failedEntries[0]);
        worksheet.addRow(headers);
        failedEntries.forEach(entry => {
            worksheet.addRow(headers.map(header => entry[header]));
        });


        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Invoice_Error_Report.xlsx";
        a.click();
        URL.revokeObjectURL(url);
    };

    const handleClose = () => {
        onClose()
        fetchData()
    }

    return (
        <StyledDialog
            disableEnforceFocus
            maxWidth="md"
            fullWidth={true}
            open={showModal}
        >
            <StyledDialogContent>
                <ModalHeaderContainer>
                    <Typography variant="h5">Add Registration Bulk</Typography>
                    <IconButton disabled={loading} onClick={() => handleClose()}>
                        <CloseOutlined />
                    </IconButton>
                </ModalHeaderContainer>
                <InputFieldContainer>
                    <Button
                        variant="contained"
                        sx={{
                            background: "primary",
                            borderColor: "#003974",
                            height: "50px",
                            padding: "5px 10px",
                            marginRight: "20px",
                        }}
                        onClick={handleDownload}
                    >
                        Download Template
                    </Button>

                    <input
                        key={fileKey}
                        type="file"
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        onChange={handleFileUpload}
                        style={{ display: "none" }}
                        ref={fileInputRef}
                    />

                    <Button
                        variant="contained"
                        sx={{
                            background: "primary",
                            borderColor: "#003974",
                            height: "50px",
                            padding: "5px 10px",
                            marginRight: "20px",
                        }}
                        onClick={handleButtonClick}
                    >
                        Select File
                    </Button>

                    {selectedFile && (
                        <Button
                            variant="contained"
                            color="success"
                            sx={{
                                height: "50px",
                                padding: "5px 10px",
                                marginRight: "20px",
                            }}
                            onClick={handleUpload}
                            disabled={loading}
                        >
                            {loading ? "Uploading..." : "Upload"}
                        </Button>
                    )}
                </InputFieldContainer>

                {uploadStats && (
                    <div style={{
                        marginTop: "20px",
                        padding: "15px",
                        borderRadius: "10px",
                        background: "#f8f9fa",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                        textAlign: "center"
                    }}>
                        <Typography variant="h6" style={{ fontWeight: "bold", marginBottom: "10px" }}>
                            Upload Summary
                        </Typography>
                        <div style={{ display: "flex", justifyContent: "center", gap: "20px" }}>
                            <div style={{ textAlign: "center" }}>
                                <Typography variant="h6" color="green">{uploadStats.successCount}</Typography>
                                <Typography variant="body2">Successful Entries</Typography>
                            </div>
                            <div style={{ textAlign: "center" }}>
                                <Typography variant="h6" color="red">{uploadStats.failureCount}</Typography>
                                <Typography variant="body2">Failed Entries</Typography>
                            </div>
                            <div style={{ textAlign: "center" }}>
                                <Typography variant="h6" color="blue">{uploadStats.total}</Typography>
                                <Typography variant="body2">Total Entries</Typography>
                            </div>
                        </div>


                        <div style={{ marginTop: "15px", width: "100%", height: "10px", background: "#e0e0e0", borderRadius: "5px" }}>
                            <div style={{
                                width: `${(uploadStats.successCount / uploadStats.total) * 100}%`,
                                height: "100%",
                                background: "green",
                                borderRadius: "5px"
                            }}></div>
                        </div>

                        {failedEntries.length > 0 && (
                            <Button
                                variant="contained"
                                color="error"
                                onClick={handleDownloadErrorReport}
                                style={{ marginTop: "15px" }}
                            >
                                Download Error Report
                            </Button>
                        )}
                    </div>
                )}


            </StyledDialogContent>
        </StyledDialog>
    );
};

export default BulkAddMainRegistration;

